import { useTourRegions } from "@src/hooks//useTourRegions"
import { getAncestorList } from "@src/utils/trees"
import { useTourCategories } from "./useTourCategories"
export const useTourBreadcrumbs = (regionId, categoryId) => {
  const tourRegionsList = useTourRegions()
  const tourCategoriesList = useTourCategories()
  const ancestorList = getAncestorList(regionId, tourRegionsList)
  const headerBreadcrumbs = []
  headerBreadcrumbs.push({
    text: "Tours",
    link: "/tours/",
  })
  const category =
    categoryId && tourCategoriesList.find(item => item.id === categoryId)

  if (ancestorList && ancestorList.length) {
    ancestorList.forEach((ancestor, index) => {
      const ancestorRegion = tourRegionsList.find(item => item.id === ancestor)
      const { name: text, uri: link } = ancestorRegion
      headerBreadcrumbs.push({
        text,
        link,
      })
      if (category && index + 1 === ancestorList.length) {
        category.region = ancestorRegion.name
        category.regionSlug = ancestorRegion.slug
      }
    })
  }
  if (category) {
    if (category.region) {
      headerBreadcrumbs.push({
        text: `${category.region} ${category.name} Tours`,
        link: `/tours/${category.regionSlug}-${category.slug}/`,
      })
    } else {
      headerBreadcrumbs.push({
        text: `${category.name} Tours`,
        link: `/tours/${category.slug}/`,
      })
    }
  }

  return { headerBreadcrumbs }
}
